const MIN_LENGTH = 12
const MAX_LENGTH = 100

function check(password?: string) {
  if (!password) return false
  return MIN_LENGTH <= password?.length && password?.length <= MAX_LENGTH
}

export default { check, MAX_LENGTH, MIN_LENGTH }
